export default "__VITE_ASSET__B8g5vzaR__"